import {
    formatValue,
} from './format-value';

export function checkValue(value: string, regexPattern: string): boolean {
    const formattedValue = formatValue(value);

    if (!formattedValue) {
        return false;
    }

    try {
        const regex = new RegExp(regexPattern);

        return regex.test(formattedValue);
    } catch (_e) {
        return false;
    }
}
